import Workbench from './workbench.vue'
import {jump} from '@utils';


export default [{
    path: '/workbench',
    name:'workbench',
    component: Workbench,
    beforeEnter: (to, from, next) => {
        jump.preWorkbench(()=>{
            next({name:'enterManage'})  
        })
      }
}]